import React, { useEffect, useState } from 'react';
import './SurgirhoverList.scss';
import Santander from '../../../../assets/icons/santanderL.svg';
import Surgir from '../../../../assets/images/logo_nuevo.png';

import { Navbar, } from "react-bootstrap";
import SurgirButton from 'components/ui/SurgirButton/SurgirButton';

interface Option {
	title: string;
	description: string;
	link: string;
	targetBlank: boolean;
	keywords: string;
}

interface Section {
	icon: string;
	title: string;
	options: Option[];
}

interface MenuItem {
	title: string;
	children: boolean;
	link: string;
	sections: Section[];
}

export interface SurgirhoverListProps {
	menuItems: MenuItem[];
	onSearch?: () => void;
}

const SurgirhoverList: React.FC<SurgirhoverListProps> = ({ menuItems, onSearch }) => {
	const [hoveredItem, setHoveredItem] = useState<number | null>(null);
	const [activeSearch, setActiveSearch] = useState(false);
	const [isDisplayed, setIsDisplayed] = useState(false);
	const [innerHeight, setInnerHeight] = useState(0);
	const handleClick = (value: boolean) => {
		setActiveSearch(value);
		onSearch && onSearch();
	};

	const handleButtonClick = () => {
		window.location.href = '/abre-tu-deposito-a-plazo-fijo';
	};

	const handleMouseEnter = (itemId: number) => {
		setHoveredItem(itemId);
		handleDropdownHover(itemId);
	};
	const handleMouseLeave = () => {
		setHoveredItem(null);
	};

	const backdrop = (index: any) => {
		console.log('fuera', index)
		setHoveredItem(null);
		const icon = document.getElementById(`rotar-${index}`)
		icon?.classList.add('rotate-icon')
		const dropdownItem = document.getElementById(`dropdown-item-${index}`);
		const desapear2 = document.getElementsByClassName(`backdrop `);
		const desapearArray2 = Array.from(desapear2);
		if (dropdownItem) {
			desapearArray2.forEach((element, index) => {
				element.classList.add('no-display');
			});
		}
	}

	const backdropOut = (itemId: number) => {
		const dropdownItem = document.getElementById(`dropdown-item-${itemId}`);
		const desapear2 = document.getElementsByClassName(`backdrop`);
		const desapearArray2 = Array.from(desapear2);
		if (dropdownItem) {
			desapearArray2.forEach((element, index) => {
				element.classList.remove('no-display');
			});
		}
		setHoveredItem(itemId);
		handleDropdownHover(itemId);
		const icon = document.getElementById(`rotar-${itemId}`)
		icon?.classList.remove('rotate-icon')

	};

	const handleDropdownHover = (itemId: number) => {
		const dropdownItem = document.getElementById(`dropdown-item-${itemId}`);
		const desapear = document.getElementsByClassName(`option-content1`);
		const desapear3 = document.getElementsByClassName(`option-content`);
		const desapear2 = document.getElementsByClassName(`full-width-content`);
		const desapearArray2 = Array.from(desapear2);
		const desapearArray3 = Array.from(desapear3);
		const desapearArray = Array.from(desapear);

		if (dropdownItem) {
			desapearArray2.forEach((element, index) => {
				if (index === 6) {
					element.classList.add('no-display');
				}
			});
			desapearArray.forEach((element) => {
				element.classList.add('no-display');
			});
			desapearArray3.forEach((element) => {
				element.classList.add('fixer-display');
			});

		}
	};


	const [openIndex, setOpenIndex] = useState<number | null>(null);
	const [rotations, setRotations] = useState<number[]>(Array(menuItems.length).fill(0));

	const handleMenuItemClick = (index: number) => {
		setOpenIndex(openIndex === index ? null : index);
		const isOpening = openIndex !== index;
		const dropdownItem = document.getElementById(`dropdown-movile-${index}`);
		if (dropdownItem) {
			const allDropdowns = document.querySelectorAll('.option-content-movile');
			allDropdowns.forEach((dropdown, i) => {
				const htmlDropdown = dropdown as HTMLElement;
				if (i === index) {
					if (isOpening) {
						setTimeout(() => {
							htmlDropdown.style.opacity = "1";
							htmlDropdown.style.maxHeight = "500px";
							htmlDropdown.style.paddingBottom = "24px";
						}, 10);
					} else {
						htmlDropdown.style.opacity = "0";
						htmlDropdown.style.maxHeight = "0";
						htmlDropdown.style.paddingBottom = "0px";
					}
				} else {
					htmlDropdown.style.opacity = "0";
					htmlDropdown.style.maxHeight = "0";
					htmlDropdown.style.paddingBottom = "0";
				}
			});
		}

		setRotations(prevRotations => {
			const newRotations = prevRotations.map((rotation, i) => {
				if (i === index) {
					return isOpening ? 180 : 0;
				} else {
					return 0;
				}
			});
			return newRotations;
		});
	};

	const [scrollPosition, setScrollPosition] = useState(0);
	const [isTopScroll, setIsTopScroll] = useState(true);
	const handleScroll = () => {
		const position = window.scrollY;
		setScrollPosition(position);
	};

	const handleResize = () => {
		setInnerHeight(window.innerHeight - 48 - 38);
	};

	useEffect(() => {
		setInnerHeight(window.innerHeight - 48 - 38);
		window.addEventListener('scroll', handleScroll);
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('scroll', handleScroll);
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		setIsTopScroll(scrollPosition === 0);
	}, [scrollPosition]);
	const getClassForIndex = (currentIndex: number | null) => {
		if (currentIndex === openIndex) {
			return 'clicked';
		} else if (openIndex !== null) {
			return 'non-clicked';
		} else {
			return 'inactive-navbar';
		}
	};

	const getDropdownClass = (index: number) => {
		if (hoveredItem === index) {
			return 'hovered';
		} else if (hoveredItem !== null) {
			return 'non-hovered';
		} else {
			return 'inactive-navbar';
		}
	};

	return (
		<Navbar className={`navbar-surgir ${isTopScroll ? '' : 'navbar-shadow nav-mobile-fixed'}`}>
			<div className={`rojo ${isTopScroll ? '' : 'transition'}`}>
				<div className='content-rojo'>
					<div className='rojo-logo-surgir'>
						<div className='logo-surgir'>
							<p className="l-unete">Somos parte de </p>
							<a href="https://www.santander.com.pe/" target='blank'>
							<img
								className="d-block lsurgir"
								src={Santander}
								alt="Logo"
							/></a>
						</div>
						{/* <a href="https://www.linkedin.com/company/surgir-santander-microfinanzas/"><p className="l-unete">Únete a Fondos Colectivos</p></a> */}
					</div>


				</div>
			</div>
			<div className='content-responsiv ' >
				<div className='navbar content-responsive' >
					<a href="/">
						<img
							className="d-block-fc logo"
							src={Surgir}
							alt="Logo"
						/>
					</a>
					<div className={`nav-desktop ${activeSearch && 'mode-active-search'}`}>
						{menuItems.map((menuItem, index: any) => (

							<div
								id={`dropdown-item-${index}`}
								className=
								{`dropdown ${getDropdownClass(index)}`}
								key={menuItem.title}
								onMouseEnter={() => handleMouseEnter(index)}
								onMouseLeave={handleMouseLeave}
							>
								<a href={menuItem.link || "#"}>
									{menuItem.title}
									{menuItem.sections && menuItem.sections.length > 0 && (
										<img
											id={`rotar-${index}`}
											className="d-block img arrow_up"
											style={{ width: "12px", height: "12px" }}
											alt="arrow_up"
										/>
									)}
								</a>
								{menuItem.children && (
									<div className={`dropdown-content ${isTopScroll ? '' : 'scroll-fixer-desktop'} ${hoveredItem === index ? 'visible' : ''}`}>
										<div
											onMouseEnter={() => backdrop(index)}
											onMouseLeave={() => backdropOut(index)}
											className="backdrop" >
										</div>
										<div className="dropdown-content-body">
											<div className="full-width-content">
												<div className="option-content1">
													{menuItem.children && hoveredItem === index && (
														<ul>
															<div className="img-card">
																<p className="img-text">¡Haz crecer tu dinero con una Super Tasa!</p>
																<SurgirButton
																	onClick={handleButtonClick}
																	radius={'50px'}
																	fontFamily={"SantanderTextW05-Bold"}
																	width='137px'
																	height='32px'
																	marginTop="10px"
																	variant="danger"
																>
																	Solicítalo ahora
																</SurgirButton>
																<img
																	className="d-block"
																	src="../surgir_percentage.png"
																	alt="Logo"
																/>
															</div>
														</ul>
													)}

												</div>
												<div className="option-content">
													{menuItem.children && hoveredItem === index && (
														<ul>
															{menuItem.sections.map((section) => (
																<div key={section.title} className="option-card">
																	<li >
																		<p className="tittle-option-content">
																			<img className={`d-block img ${section.icon}`}
																				style={{ width: "20px", height: "20px" }}
																				alt="iconinfo"
																			></img>{section.title}</p>
																		<ul className="ul-card">
																			{section.options.map((option) => (
																				<li key={option.link}>
																					<a className="option-card-li"
																						href={option.link}
																						target={option.targetBlank ? '_blank' : '_self'}
																						rel={option.targetBlank ? 'noopener noreferrer' : ''}
																					>
																						<p className='a-title'>{option.title}</p>
																						<p className='a-description'>{option.description}</p>
																					</a>
																				</li>
																			))}
																		</ul>
																	</li>
																</div>

															))}
														</ul>
													)}
												</div>
											</div>
										</div>
									</div>)}
							</div>
						))}
					</div>
					 <div className='nav-icons'>
						<div className="d-flex gap-3">
							
							{!isDisplayed && (
								<div className="container-search-icon">
									{activeSearch ? (
										<button
											className="d-block close-ic custom-button-icon"
											onClick={() => handleClick(false)}
										>
											<img
												alt="close"
											/>
										</button>

									) : (
										<button
											className="d-block custom-button-icon"
											onClick={() => handleClick(true)}
										>
											<img
												alt="search"
											/>
										</button>
										
									)}
								</div>
							)}
							<div className='container-search-icon'>
								{!activeSearch && isDisplayed ? (
										<button
											className="in-circle close-ic custom-button-icon"
											onClick={() => setIsDisplayed(false)}
										>
											<img
												alt="close"
											/>
										</button>
									) : (
										<button
											className="in-circle burger custom-button-icon"
											onClick={() => setIsDisplayed(true)}
										>
											<img
												alt="burger"
											/>
										</button>
									)}
						
				
							</div>
							
						</div>
					</div>

					<div className='nav-icons-movile'>
						<div className="d-flex gap-3">
							<div className="container-search-icon">
								{activeSearch ? (
									<button
										className="d-block close-ic custom-button-icon"
										onClick={() => handleClick(false)}
									>
										<img
											alt="close"
										/>
									</button> 
									
								) : (
									<button
										className="d-block custom-button-icon"
										onClick={() => handleClick(true)}
									>
										<img
											alt="search"
										/>
									</button>
								)}
							</div>
						</div>
					</div> 
				</div>
			</div>

			{/* {isDisplayed && ( */}
				<div className={`nav-mobile-content ${isTopScroll ? '' : 'scroll-fixer-mobile'}`} style={{ display: 'block', maxHeight: isDisplayed ? `${innerHeight}px` : '0' }}>
					<div className="nav-movile" style={{ maxHeight: "100vh", height: "100%", margin: "auto" }}>
						{menuItems.map((menuItem, index) => (
							<button
								type='button'
								className={`custom-button dropdown-movile ${getClassForIndex(index)}`}
								key={menuItem.title}
								onClick={() => handleMenuItemClick(index)}
							>
								<a href={menuItem.link || "#"} onClick={() => handleMenuItemClick(index)}>
									{menuItem.title}
									{menuItem.sections && menuItem.sections.length > 0 && (
										<img
											className="d-block img arrow_up"
											style={{ width: "20px", height: "20px", transform: `rotate(${rotations[index]}deg)` }}
											alt="arrow_up"
										/>
									)}
								</a>
								{menuItem.children && (
									<div id={`dropdown-movile-${index}`} className="option-content-movile block" style={{paddingBottom: ''}}>
										{menuItem.children && (
											<ul>
												{menuItem.sections.map((section) => (
													<div key={section.title} className="option-card" >
														<li>
															<p className="tittle-option-content-movile">
																{section.title}
															</p>
															<ul className="ul-card">
																{section.options.map((option) => (
																	<li key={option.link}>
																		<a
																			href={option.link}
																			target={option.targetBlank ? '_blank' : '_self'}
																			rel={option.targetBlank ? 'noopener noreferrer' : ''}
																		>
																			<p className='a-title'>{option.title}</p>
																		</a>
																	</li>
																))}
															</ul>
														</li>
													</div>
												))}
											</ul>
										)}
									</div>
								)}
							</button>
						))}
					</div>
				</div>
			{/* )} */}




		</Navbar>
	);
};

export default SurgirhoverList;
